import { cn } from '../cn'

interface ViewSwitcherView {
  value: string
  label: string
  icon?: React.ComponentType<{ className?: string }>
  /** Subtle quantity indicator rendered after the label (e.g. a record count). */
  badge?: React.ReactNode
  disabled?: boolean
  disabledReason?: string
}

interface ViewSwitcherProps {
  view: string
  onViewChange: (view: string) => void
  views: ViewSwitcherView[]
}

function ViewSwitcher({ view, onViewChange, views }: ViewSwitcherProps) {
  return (
    <div className="flex gap-1">
      {views.map((v) => {
        const Icon = v.icon
        return (
          <button
            key={v.value}
            type="button"
            disabled={v.disabled}
            title={v.disabledReason}
            onClick={() => {
              if (!v.disabled) {
                onViewChange(v.value)
              }
            }}
            className={cn(
              'flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors -mb-px',
              view === v.value
                ? 'border-foreground text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
              v.disabled && 'cursor-not-allowed opacity-50 hover:text-muted-foreground',
            )}>
            {Icon && <Icon className="h-4 w-4" />}
            <span className={Icon ? 'hidden sm:inline' : undefined}>{v.label}</span>
            {v.badge != null && (
              <span
                className={cn(
                  'inline-flex min-w-5 items-center justify-center rounded-full bg-muted px-1.5 py-px text-xs font-medium tabular-nums',
                  view === v.value ? 'text-foreground' : 'text-muted-foreground',
                )}>
                {v.badge}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export { ViewSwitcher, type ViewSwitcherProps, type ViewSwitcherView }
